import React from "react";

import { storage } from "../../../helpers/Firebase";

const Image = ({ updateValue, value, refURL }) => {
  const ref = storage.ref(refURL);

  const uploadFile = (file) => {
    const timeStamp = Date.now();

    const imageRef = ref.child(`${timeStamp}`);

    imageRef.put(file).then(
      async () => {
        const downloadURL = await imageRef.getDownloadURL();

        updateValue(downloadURL);
      },
      (e) => {
        console.log("ERROR", e);
      }
    );
  };

  return (
    <>
      <div className="align-items-center row">
        {value && <img src={value} className="col-2" alt="img" />}
        <div className={`mb-3 ${value ? "col-10" : "col-12"}`}>
          <input
            type="file"
            id={`file_upload_custom_input`}
            onChange={(e) => {
              uploadFile(e.target.files[0]);
            }}
          />
        </div>
      </div>
    </>
  );
};

export default Image;
